module.exports = __webpack_public_path__ + "static/media/karna_depth.4124cb23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/karna_depth.png
// module id = 393
// module chunks = 0